import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import {
  TableActionsDownload,
  // TableActionsDownload,
} from "../../../Components/Misc/Actions";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Autocomplete, Box, Checkbox, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import Pagination from "@mui/material/Pagination";
import Popover from "@mui/material/Popover";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { formatDate } from "../../../../../utils/hooks/convertDate";
import { convertToDecimal } from "../../../../../utils/hooks/useConvertToDecimal";
import {
  useApprovePaymentRequestMutation,
  useGetAllPaymentRequstQuery,
  useGetBudgetDetailsQuery,
  useGetLedgerAccountsQuery,
  useLinkBudgetToPaymentMutation,
  useLinkToLedgerMutation,
  useGetBudgetSummaryQuery,
} from "../../../../api";
import { BackButtons } from "../../../../global/components/Buttons/buttons";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { SearchFilter } from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import edit from "../../../Images/Edit.png";
import thumbsUp from "../../../Images/Thumbs-up.svg";
import DashboardStyle from "../../../Styles//Dashboard.module.css";
import CustomModal from "../PayrollAutoRun/components/CustomModal";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { Spinner } from "../../../Components/Loader/Spinner";
import { FormatStatus } from "../../../../../utils/functions/FormatStatus";
import {
  GetPaymentTerms,
  GetSingleProcQuotations,
} from "../../../../../utils/redux/Procurement/ProcurementSlice";
import { useDispatch, useSelector } from "react-redux";
import CreateAccrued from "./createAccrued";
import { RiEyeLine } from "react-icons/ri";
import { useFinanceGetQuery } from "../../../../api/financeApi";
import { URL } from "../../../../../utils/routes";
import PreviewBtn from "../../../Components/Modals/PreviewBtn";

let currentHeaders = [
  {
    title: "ID",
    key: "ID",
  },
  {
    title: "Recipient",
    key: "Recipient",
  },
  {
    title: "Date",
    key: "Date",
  },
  {
    title: "Amount",
    key: "Amount",
  },
  {
    title: "Account Number",
    key: "AccountNumber",
  },
  {
    title: "State",
    key: "State",
  },
  {
    title: "Is Spread Payment",
    key: "isSpreadPayment",
  },
  {
    title: "Request Status",
    key: "RequestStatus",
  },
  {
    title: "Actions",
    key: "Actions",
  },
];

const PaymentDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const paymentTerms = useSelector(
    (state) => state?.procurement?.paymentTerms?.result
  );
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const params = useParams();
  const parsedId = JSON.parse(params.data);
  console.log("parsedId", parsedId);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popover, setPopover] = React.useState(null);
  const handlePopoverClick = (event) => {
    setPopover(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setPopover(null);
  };
  const [budgetAmount, setBudgetAmount] = useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [veiwAccrued, setViewAccrued] = useState(false);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const token = JSON.parse(localStorage.getItem("user"))?.userToken;
  const hrRoot = process.env.REACT_APP_BACKEND_HR_URL;
  const [search, setSearch] = useState("");
  const [page, setPage] = React.useState(1);
  const [open, setOpen] = useState(false);
  const [isYear, setIsYear] = useState(new Date().getFullYear());
  const [pageSize] = useState(1000000);
  const [pageNumber] = useState(1);
  const [departmentCreditValue] = useState(1);
  const [departmentDebitValue] = useState(0);

  const [openAction, setOpenAction] = useState(false);
  const [isId, setIsId] = useState(null);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState("");
  const [total, setTotal] = useState("");
  useEffect(() => {
    const getDepartment = async () => {
      try {
        const res = await axios.get(
          `${hrRoot}/Department/AllDepartment?&PageSize=${pageSize}&PageNumber=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res) {
          setData(res?.data?.responseObject?.pageItems);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getDepartment();
  }, []);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const [checked, setChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setIsloading] = useState(false);
  const [isDebitLedgerId, setIsDebitLedgerId] = useState();
  const [isCreditLedgerId, setIsCreditLedgerId] = useState();
  const [departmentValue, setDepartmentValue] = useState();
  const [budgetValue, setBudgetValue] = useState();
  const [budgetId, setBudgetId] = useState();
  const [anchorElLedger, setAnchorElLedger] = React.useState(null);
  const handleCloseLedger = () => {
    setAnchorElLedger(null);
  };
  const handleOpenLedger = (event) => {
    setAnchorElLedger(event.currentTarget);
  };
  const openPopoverMini = Boolean(popover);
  const popOverId = openPopoverMini ? "simple-popover" : undefined;
  const popOverOpenLedger = Boolean(anchorElLedger);

  const ledgerId = popOverOpenLedger ? "simple-popover" : undefined;
  const navigate = useNavigate();
  const {
    data: paymentReqData,
    isLoading: loadingData,
    error,
    isError,
    refetch,
  } = useGetAllPaymentRequstQuery({
    BatchId: parsedId?.batchId,
    PaymentTypeId: parsedId?.PaymentTypeId ? parsedId?.PaymentTypeId : null,
    CreatedDate: parsedId?.CreatedDate ? parsedId?.CreatedDate : null,
  });

  // console.log("parsedId", parsedId);
  console.log("paymentReqData?.responseObject[0]", paymentReqData);
  const details = paymentReqData?.responseObject || [];

  const handleSelectAll = (isChecked) => {
    setChecked(isChecked);
    if (isChecked) {
      const Ids = paymentReqData?.responseObject?.map((item) => item).flat();
      setSelectedItems(Ids);
    } else {
      setSelectedItems([]);
    }
  };
  const { data: budgetDetails } = useGetBudgetDetailsQuery({
    pageSize,
    pageNumber,
    SummaryId: budgetId,
  });
  const { data: ledgerDetails, error: ledgerDetailsError } =
    useGetLedgerAccountsQuery({
      pageSize,
      pageNumber,
      ApprovalStatus: 0,
    });
  console.log("data", data);
  const { data: budgetSummaryData } = useGetBudgetSummaryQuery({
    Year: isYear,
    Department: departmentValue,
    pageSize,
    PageNumber: pageNumber,
  });
  const handleCheckboxChange = (item, isChecked) => {
    if (isChecked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((items) => items?.id !== item.id)
      );
    }
  };

  function createYearArray() {
    const currentYear = new Date().getFullYear();
    const lowestYear = 2002;
    const years = [];

    for (let year = currentYear; year >= lowestYear; year--) {
      years.push(year);
    }

    return years;
  }
  const yearArray = createYearArray();
  const itemsPerPage = 10;
  const filteredData = paymentReqData?.responseObject?.filter((item) =>
    item?.recipent?.toLowerCase().includes(search?.toLowerCase())
  );

  const slicedData = paymentReqData?.responseObject?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );
  const [openModal, setOpenModal] = useState(false);
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const handleModal = () => {
    setOpenModal(true);
    setPopover(null);
  };

  const [onLinkBudget] = useLinkBudgetToPaymentMutation();
  const handleLinkBudget = async () => {
    try {
      setIsloading(true);
      const res = await onLinkBudget({
        BatchId: parsedId?.batchId,
        BudgetId: isId,
      }).unwrap();
      if (res.successful === true) {
        setIsloading(false);
        handleClose();
        setOpenModal(false);
        toast.success(res?.statusMessage);
        refetch();
      }
    } catch (err) {
      setIsloading(false);
      // setOpen(false);
      // handleClose();
      // setOpenModal(false);
      toast.error(err?.data?.statusMessage);
    }
  };
  const [onLinkToLedger] = useLinkToLedgerMutation();
  const handleLinkToLedger = async () => {
    try {
      setIsloading(true);
      const res = await onLinkToLedger({
        BatchId: parsedId?.batchId,
        DebitLedgerId: isDebitLedgerId,
        DebitAccountPosition: departmentDebitValue,
        CreditAccountPosition: departmentCreditValue,
        CreditLedgerId: isCreditLedgerId,
      }).unwrap();
      if (res.successful === true) {
        setIsloading(false);
        handleCloseLedger();
        toast.success(res?.statusMessage);
        refetch();
      } else if (res.successful === false) {
        setIsloading(false);
        // handleCloseLedger();
        toast.error(res?.statusMessage);
      }
    } catch (err) {
      setIsloading(false);
      // setOpen(false);
      console.log(err);
      // handleCloseLedger();
      toast.error(err?.data?.statusMessage);
    }
  };
  const [onApprovePaymentReq] = useApprovePaymentRequestMutation();
  const handleApprovePaymentRequest = async () => {
    try {
      setIsloading(true);
      const res = await onApprovePaymentReq({
        paymentIds: slicedData?.length > 1 ? selectedItems?.id : [parsedId.id],
        Status: location.pathname?.includes(URL.PaymentRequestHOD) ? 103 : 0,
        Comment: "Approved",
      }).unwrap();
      if (res.successful === true) {
        toast.success(res?.statusMessage);
        setIsloading(false);
        setOpen(false);
      } else if (res.successful === false) {
        setOpen(false);
        setIsloading(false);
        toast.error(res?.statusMessage);
      }
    } catch (err) {
      setIsloading(false);
      setOpen(false);
      toast.error(err?.data?.statusMessage);
    }
  };

  const budgetData = budgetSummaryData?.result ?? [];

  useEffect(() => {
    if (
      paymentReqData?.responseObject?.length > 0 &&
      paymentReqData?.responseObject[0]?.processId >= 0
    ) {
      dispatch(
        GetSingleProcQuotations(paymentReqData?.responseObject[0]?.processId)
      );
      dispatch(GetPaymentTerms(paymentReqData?.responseObject[0]?.processId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentReqData]);
  const delivery_status =
    details?.assetDelivery === "Delivered" &&
    details?.rating === "Satisfactory" &&
    details?.serviceDelivery === "Approved"
      ? "Delivered"
      : "Not Delivered";

  // get most recent year
  // const mostRecentYear = new Date().getFullYear();
  console.log("selectedItems", selectedItems);

  const { data: records } = useFinanceGetQuery(
    `PayrollPayment/GetAccruedById/${ids}`,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const [dates, setDates] = useState([]);

  useEffect(() => {
    const getNextMonthsWithDates = (startDate, monthDuration) => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const start = new Date(startDate);
      const day = start.getDate();
      const currentMonth = start.getMonth();
      const currentYear = start.getFullYear();

      const nextMonths = [];

      for (let i = 0; i <= monthDuration; i++) {
        const newMonthIndex = (currentMonth + i) % 12; // Get month index
        const newYear = currentYear + Math.floor((currentMonth + i) / 12); // Handle year change

        nextMonths.push(`${months[newMonthIndex]} ${day}, ${newYear}`);
      }

      return nextMonths;
    };
    setDates(
      getNextMonthsWithDates(
        records?.responseObject?.startDate,
        records?.responseObject?.monthDuration
      )
    );
  }, [records]);
  const [action, setAction] = useState(false);
  return (
    <>
      <Modal open={veiwAccrued} onClose={() => setViewAccrued(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 10,
          }}
        >
          <div className="flex justify-between text-xl font-bold text-black">
            <p className=" text-3xl">Veiw Accrued Payment</p>{" "}
            <p
              onClick={() => setViewAccrued(false)}
              className="text-3xl cursor-pointer"
            >
              X
            </p>
          </div>
          <div
            className={`${DashboardStyle.labels_group} mt-10 h-64 overflow-y-auto`}
          >
            {dates?.map((date, index) => {
              return index < dates.length - 1 ? (
                <div key={index}>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        marginBottom: "0.8rem",
                        gap: "0.6rem",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ marginBottom: "0px" }}>Amount:</p>
                      <h4>
                        {(
                          records?.responseObject?.amount /
                          records?.responseObject?.monthDuration
                        )?.toLocaleString()}
                      </h4>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        marginBottom: "0.8rem",
                        gap: "0.6rem",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ marginBottom: "0px" }}>End Date:</p>
                      <h4>{FormatDateTime(dates[index + 1])}</h4>
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        marginBottom: "0.8rem",
                        gap: "0.6rem",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ marginBottom: "0px" }}>Start Date:</p>
                      <h4>{FormatDateTime(date)}</h4>
                    </div>

                    <div className="flex space-x-3 items-baseline">
                      <p>Month Duration:</p>
                      <h4>{records?.responseObject?.monthDuration}</h4>
                    </div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </Box>
      </Modal>

      {loading && <Spinner />}
      {loadingData && <Spinner />}
      <RouteLayout>
        <div>
          <BackButtons onClick={() => navigate(-1)} />
        </div>
        <div>
          <p>{loadingData && "Please wait while data is loading..."}</p>
          <p>{isError && <div>{error?.data?.statusMessage}</div>}</p>
        </div>
        {/* {slicedData?.length === 1 && ( */}
        <PageStyle>
          <div className="mb-5 flex justify-between items-center">
            <div>
              <h2 className="text-[#4B664C] text-[32px] font-[400]">
                Payment Request
              </h2>
            </div>
            {type !== "controlApproval" && (
              <div className="flex items-center justify-end gap-2">
                <button
                  onClick={(e) => {
                    handlePopoverClick(e);
                    setAction(true);
                  }}
                  className="text-baseFont bg-customGreen py-5 px-7 rounded text-white"
                >
                  Action
                  <KeyboardArrowDownIcon sx={{ color: "#fff" }} />
                </button>
              </div>
            )}
          </div>
          <div>
            <div className="mb-5">
              <PaymentTabLayout>
                <div className="flex gap-10">
                  <div className="w-[30%]">
                    <p className="text-[#6E9170] font-[400] text-[12px]">
                      Request Details
                    </p>
                  </div>
                  <div className="flex flex-col w-full gap-y-5">
                    <div className="grid grid-cols-3 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Batch ID:{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.batchId ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Recipients{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.recipent ??
                            "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Type{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.paymentType ??
                            "--"}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Requisition Date
                        </p>
                        <p>
                          {FormatDateTime(
                            paymentReqData?.responseObject?.[0]?.createdDate
                          ) ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Total Amount{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.totalAmount ??
                            "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Active{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]
                            ?.registrationState ?? "--"}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Inactive{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]
                            ?.registrationState ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Status{" "}
                        </p>
                        {/* FormatStatus */}
                        <p>
                          {/* {paymentReqData?.responseObject?.[0]
                              ?.approvalStatus === 0
                              ? "Approved"
                              : "Pending"} */}
                          {FormatStatus(
                            paymentReqData?.responseObject?.[0]?.approvalStatus
                          ) ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Narration
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.narration ??
                            "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Delivery Status
                        </p>
                        <p
                          style={{
                            color:
                              delivery_status === "Delivered"
                                ? "#6E9170" // Green for "Delivered"
                                : delivery_status === "Not Delivered"
                                ? "red" // Red for "Not Delivered"
                                : "gray", // Gray for any other status
                          }}
                        >
                          {delivery_status}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Description
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.description ??
                            "--"}
                        </p>
                      </div>

                      <div className="max-w-[200px]">
                        <PreviewBtn
                          title="Preview Approval"
                          allData={
                            paymentReqData?.responseObject?.approvalResponse
                          }
                          data={
                            paymentReqData?.responseObject?.approvalResponse
                              ?.history || []
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </PaymentTabLayout>
            </div>
            <div className="mb-5">
              <PaymentTabLayout>
                <div className="flex gap-10">
                  <div className="w-[30%]">
                    <p className="text-[#6E9170] font-[400] text-[12px]">
                      Budget Details
                    </p>
                  </div>
                  <div className="flex flex-col w-full gap-y-5">
                    <div className="grid grid-cols-3 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Budget Type
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.budget
                            ?.budgetType ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Category
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.budget
                            ?.category ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Type{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.budget
                            ?.itemType ?? "--"}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Requisition Date
                        </p>
                        <p>
                          {FormatDateTime(
                            paymentReqData?.responseObject?.[0]?.budget?.date
                          ) ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Total Amount{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.budget?.total ??
                            "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Status{" "}
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.budget
                            ?.approvalStatus === 0
                            ? "Approved"
                            : "Pending"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </PaymentTabLayout>
            </div>
            <div className="mb-5">
              <PaymentTabLayout>
                <div className="flex gap-10">
                  <div className="w-[30%]">
                    <p className="text-[#6E9170] font-[400] text-[12px]">
                      Ledger Details
                    </p>
                  </div>
                  <div className="flex flex-col w-full gap-y-5">
                    <div className="grid grid-cols-2 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Transaction Entry
                        </p>
                        <p>Debit</p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Chart of Account
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.debitLedger
                            ?.accountName ?? "--"}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 w-full gap-y-5">
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Transaction Entry
                        </p>
                        <p>Credit</p>
                      </div>
                      <div>
                        <p className="text-[#6E9170] font-[400] text-[12px]">
                          Chart of Account
                        </p>
                        <p>
                          {paymentReqData?.responseObject?.[0]?.creditLedger
                            ?.accountName ?? "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </PaymentTabLayout>
            </div>
          </div>

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Payment Terms</h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Installement Amount</th>
                    <th>Installement Percentage</th>
                    <th>Payment Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentTerms?.map((x, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{x?.installementAmount}</td>
                      <td>{x?.installementPercentage}</td>
                      <td>{FormatDateTime(x?.paymentDate)}</td>
                      <td>
                        {x?.isSentForPayment === null
                          ? "Pending"
                          : x?.isSentForPayment === false
                          ? "Declined"
                          : "Sent"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </section>

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Sub Classes</h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Components</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentReqData?.responseObject?.[0]?.subclasses?.map(
                    (x, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{x?.componentName}</td>
                        <td>{x?.amount}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
          </section>

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Documents <br /> Uploads
            </h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Document Name</th>
                    <th>Document Size</th>
                    <th>Document Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentReqData?.responseObject?.[0]?.documentResponse?.map(
                    (x, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{x?.fileName}</td>
                        <td>{x.size}</td>
                        <td>{x?.fileExtension}</td>
                        <td>
                          <TableActionsDownload base64File={x?.file} />
                        </td>
                        {/* <td>
                                  {base64ToFile(
                                    x?.file,
                                    x?.fileName + x?.fileExtension,
                                    "application/pdf"
                                  )}
                                </td> */}
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
          </section>

          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>Audit Logs</h4>

            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Action</th>
                    <th>Category</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentReqData?.responseObject?.[0]?.auditLogs.map(
                    (x, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{x?.action}</td>
                        <td>{x.category}</td>
                        <td>{x?.modifiedByName}</td>
                        <td>{FormatDateTime(x.modifiedDate)}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
          </section>
        </PageStyle>
        {/* )} */}
        {/* {slicedData?.length > 1 && ( */}
        <>
          <PageStyle>
            <div className="w-full flex items-end justify-between mb-3">
              {/* <div className="flex items-center justify-end gap-5">
                  <SearchFilter
                    text={(value) => setSearch(value)}
                    fromHeader={true}
                    onChange={(e) => handleSearch(e)}
                  />
                  <div>
                    <span
                      onClick={handleClick}
                      className="flex items-center gap-3 border-2 cursor-pointer border-[#6E9170] rounded-[8px] py-[12px] px-[24px]"
                    >
                      <FilterAltOutlinedIcon />
                      <span className="text-[#29382A]">Filter</span>
                    </span>
                  </div>
                </div> */}
              <div></div>
              {type !== "controlApproval" && (
                <div>
                  <button
                    disabled={selectedItems.length < 1}
                    onClick={() => setOpen(true)}
                    className="bg-[#29382A]/90 text-white px-[20px] rounded-md flex gap-3 items-center py-4"
                  >
                    {selectedItems.length < 1
                      ? "Select Items to Approve"
                      : "Approve"}
                  </button>
                </div>
              )}
            </div>
            <div className={DashboardStyle.dashboard_table_holder}>
              <Table>
                <thead>
                  <tr>
                    <th>
                      <Checkbox
                        checked={checked}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    </th>
                    {currentHeaders.map((header, _index) => (
                      <th
                        className={`!text-[#29382A] ${
                          header.title === "Actions" && "flex justify-end !pr-6"
                        }`}
                        key={_index + 1}
                      >
                        {header.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {slicedData?.map((item, index) => {
                    return (
                      <tr
                        key={item?.id}
                        onClick={() => {
                          setIds(item?.id);
                          setAction(false);
                        }}
                      >
                        <td>
                          <Checkbox
                            checked={selectedItems.includes(item)}
                            onChange={(e) =>
                              handleCheckboxChange(item, e.target.checked)
                            }
                          />
                        </td>
                        <td className="text-[#29382A] ">{item?.id}</td>
                        <td>{item?.recipent ?? "--"}</td>
                        <td>{formatDate(item?.createdDate) ?? "--"}</td>
                        <td>
                          ₦ {convertToDecimal(item?.totalAmount) ?? "--"}{" "}
                        </td>
                        <td>{item?.accountNumber ?? "--"} </td>
                        <td>{item?.registrationState}</td>
                        <td>{item?.isSpreadPayment ? "Yes" : "No"}</td>
                        <td
                          className={`${
                            item.approvalStatus === 1 && " text-[#946300]"
                          } ${item.approvalStatus === 0 && " text-[#067306]"} ${
                            item.approvalStatus === 7 && " text-[#9E0038]"
                          } px-[8px] py-[3px] rounded-[8px] text-center`}
                        >
                          {FormatStatus(item.approvalStatus) ?? "---"}
                        </td>
                        <td>
                          <div className={`flex justify-center`}>
                            <button
                              disabled={type === "controlApproval"}
                              onClick={handlePopoverClick}
                            >
                              <MoreVertIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="flex justify-between">
              <p>Showing page: {page}</p>
              <Pagination
                count={Math.ceil(
                  paymentReqData?.responseObject?.length / itemsPerPage
                )}
                page={page}
                onChange={handleChange}
              />
            </div>
          </PageStyle>
        </>
        {/* // )} */}
        <>
          {open && (
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              {/* <div className="flex justify-center items-center">
                <div className="bg-[#FFFFFF] w-[500px] p-[24px] mt-[10%] rounded-[12px]">
                  <div className="flex justify-center items-center mb-5">
                    <div className="bg-[#4B664C]/70 p-2 rounded-full">
                      <div className="bg-[#4B664C]/60 p-2 rounded-full">
                        <div className=" w-[24px] flex justify-center">
                          <p className="text-white">!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-5">
                    <h3 className="text-[18px] font-[500] text-center">
                      Approve Payment Request
                    </h3>
                  </div>
                  <div className="mb-5">
                    <p className="text-center text-[#4B664C]">
                      Are you sure you want to approve all the payroll of{" "}
                      <strong>
                        {slicedData?.length === 1 ? 1 : selectedItems?.length}
                      </strong>{" "}
                      employees
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <div>
                      <button
                        onClick={() => setOpen(!open)}
                        className="py-[10px] px-[18px] bg-[#D92D20] text-white shadow-md border rounded-[8px] w-[120px]"
                      >
                        No, Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={handleApprovePaymentRequest}
                        className=" bg-[#4B664C] py-[10px] px-[18px] text-white rounded-[8px] "
                      >
                        {loading ? "Approving..." : "Yes Approve"}
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="flex justify-center items-center">
                <div className="bg-[#FFFFFF] w-[700px] p-[24px] mt-[10%] rounded-[12px]">
                  <div className="flex justify-center items-center mb-5">
                    <div className="bg-[#4B664C]/70 p-2 rounded-full">
                      <div className="bg-[#4B664C]/60 p-2 rounded-full">
                        <div className=" w-[24px] flex justify-center">
                          <p className="text-white">!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {open !== "Accrued" ? (
                    <>
                      <div className="mb-5">
                        <h3 className="text-[18px] font-[500] text-center">
                          Approve Payment Request
                        </h3>
                      </div>
                      <div className="mb-5">
                        <p className="text-center text-[#4B664C]">
                          {selectedItems?.some(
                            (item) => item.isAcrrued === true
                          ) ? (
                            "This is an accrued Payment, are you sure you want to create Accrued payment?"
                          ) : (
                            <>
                              Are you sure you want to approve all the payment
                              request of{" "}
                              <strong>{selectedItems?.length}</strong> employees
                            </>
                          )}{" "}
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div>
                          <button
                            onClick={() => setOpen(!open)}
                            className="py-[10px] px-[18px] bg-[#D92D20] text-white shadow-md border rounded-[8px] w-[120px]"
                          >
                            No, Cancel
                          </button>
                        </div>
                        <div className="flex space-x-4">
                          <button
                            onClick={handleApprovePaymentRequest}
                            className=" bg-[#4B664C] py-[10px] px-[18px] text-white rounded-[8px] "
                          >
                            {loading ? "Approving..." : "Approve Payment"}
                          </button>
                          {selectedItems?.some(
                            (item) => item.isAcrrued === true
                          ) &&
                            selectedItems?.some(
                              (item) => item.isSpreadPayment !== true
                            ) && (
                              <button
                                onClick={() => setOpen("Accrued")}
                                className=" bg-[#4B664C] py-[10px] px-[18px] text-white rounded-[8px] "
                              >
                                Create Accured Payment
                              </button>
                            )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="h-96 overflow-y-auto">
                      <div className="mb-5">
                        <h3 className="text-[18px] font-[500] text-center">
                          Create Accrued Payment
                        </h3>
                      </div>
                      <>
                        {selectedItems
                          ?.filter(
                            (item) =>
                              item?.isAcrrued === true &&
                              item?.isSpreadPayment !== true
                          )
                          ?.map((dat) => (
                            <CreateAccrued
                              setOpenModal={setOpen}
                              record={dat}
                            />
                          ))}

                        <div className="flex justify-between">
                          <div>
                            <button
                              onClick={() => setOpen(!open)}
                              className="py-[10px] px-[18px] bg-[#D92D20] text-white shadow-md border rounded-[8px] w-[120px]"
                            >
                              No, Cancel
                            </button>
                          </div>
                          <div className="flex space-x-4">
                            <button
                              onClick={() => setOpen(true)}
                              className=" bg-[#4B664C] py-[10px] px-[18px] text-white rounded-[8px] "
                            >
                              Back
                            </button>
                          </div>
                        </div>
                      </>
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          )}
          <Modal
            id={ledgerId}
            open={popOverOpenLedger}
            anchorEl={anchorElLedger}
            onClose={handleCloseLedger}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            sx={{
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="rounded-md\">
              <div className="bg-customGreen h-[50px] w-full pt-4 pl-4">
                <p className="text-white">Update To Ledger </p>
              </div>
              <div className=" w-[512px] p-[20px] bg-[#fff]  border border-customGreen">
                <div className="grid grid-cols-2 gap-5">
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Transaction Entry
                    </h1>
                    <select
                      className="text-baseFont w-full py-3 rounded border border-slate-300 bg-white  h-[50px] px-2 outline-none focus:ring-0"
                      value={departmentCreditValue}
                      disabled
                    >
                      <option value={1}>Credit</option>
                    </select>
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Chart of Account:
                    </h1>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      disabled={!ledgerDetails?.result}
                      options={ledgerDetails?.result?.map((d) => ({
                        label: `${d?.accountName} ${d?.cost}`,
                        value: `${d?.accountName} ${d?.cost}`,
                        id: d?.id,
                      }))}
                      getOptionLabel={(option) => option.label}
                      onChange={(e, newValue) => {
                        // setIsCreditLedgerId(newValue?.value || "");
                        setIsCreditLedgerId(newValue?.id || "");
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Transaction Entry
                    </h1>
                    <select
                      className="text-baseFont w-full py-3 rounded border border-slate-300 bg-white  h-[50px] px-2 outline-none focus:ring-0"
                      disabled
                      value={departmentDebitValue}
                    >
                      <option value={0}>Debit</option>
                    </select>
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Chart of Account:
                    </h1>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      disabled={!ledgerDetails?.result}
                      options={ledgerDetails?.result?.map((d) => ({
                        label: `${d?.accountName} ${d?.cost}`,
                        value: `${d?.accountName} ${d?.cost}`,
                        id: d?.id,
                      }))}
                      getOptionLabel={(option) => option.label}
                      onChange={(e, newValue) => {
                        // setIsDebitLedgerId(newValue?.value || "");
                        setIsDebitLedgerId(newValue?.id || "");
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </div>
                </div>
                <div className="flex justify-between">
                  <div></div>
                  <div className="flex gap-5">
                    <button
                      className="text-[#29382A]"
                      onClick={() => {
                        setOpenAction(!openAction);
                        handleCloseLedger();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleLinkToLedger}
                      disabled={loading}
                      className="bg-[#29382A] text-white px-[24px] py-[12px] rounded-[8px]"
                    >
                      {loading ? "Linking..." : "Link To Ledger"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Popover
            id={popOverId}
            open={openPopoverMini}
            anchorEl={popover}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            sx={{ borderRadius: "12px" }}
          >
            <div className="p-[20px] grid gap-5">
              <div>
                <button onClick={handleModal} className="flex gap-3">
                  <img src={edit} alt="" /> <span> Update To Budget</span>
                </button>
              </div>
              <div>
                <button onClick={handleOpenLedger} className="flex gap-3">
                  <img src={edit} alt="" /> <span> Update To Ledger</span>
                </button>
              </div>
              {paymentReqData?.responseObject?.[0]?.approvalStatus !== 103 && (
                <div>
                  <button onClick={() => setOpen(true)} className="flex gap-3">
                    <img src={thumbsUp} alt="" /> <span> Approve</span>
                  </button>
                </div>
              )}
              {!action && (
                <div>
                  <button
                    onClick={() => setViewAccrued(true)}
                    className="flex gap-3 items-center"
                  >
                    <RiEyeLine className="text-green-600 text-2xl" />
                    <span>Veiw Accrued Payment</span>
                  </button>
                </div>
              )}
            </div>
          </Popover>
          {openModal && (
            <CustomModal hideModal={setOpenModal}>
              <div
                className="bg-white w-full overflow-hidden"
                style={{
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                }}
              >
                <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
                  <p className="text-white text-baseFont font-[700]">
                    Update Budget
                  </p>
                  <button
                    onClick={closeModal}
                    className="text-baseFont text-white"
                    // onClick={closeModal}
                  >
                    <FiX />
                  </button>
                </header>
                {/*main*/}
                <div className="grid grid-cols-2 gap-5 p-8">
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Department
                    </h1>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={data?.map((d, _index) => ({
                        label: d?.name,
                        value: d?.name,
                        id: d?.id,
                        key: _index,
                      }))}
                      getOptionLabel={(option) => option?.label}
                      onChange={(e, newValue) => {
                        setDepartmentValue(newValue?.value || "");
                        // setIsId(newValue?.id || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          value={departmentValue}
                          placeholder="Choose Department"
                        />
                      )}
                    />
                  </div>
                  {/* <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Year
                    </h1>
                    <select
                      className="text-baseFont w-full py-3 rounded border border-slate-300 bg-white  h-[50px] px-2 outline-none focus:ring-0"
                      onChange={(e) => setIsYear(e.target.value)}
                      // value={payrollType}
                    >
                      {yearArray.map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Budget
                    </h1>
                    <Autocomplete
                      disablePortal
                      disabled={budgetData?.length < 1}
                      id="combo-box-demo"
                      options={budgetData.map((d, _index) => ({
                        label: `Budget for ${d?.department} for year ${d?.year}`,
                        value: d?.name,
                        id: d?.id,
                        key: _index,
                      }))}
                      getOptionLabel={(option) => option?.label}
                      onChange={(e, newValue) => {
                        setBudgetValue(newValue?.value || "");
                        setBudgetId(newValue?.id || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          value={budgetValue}
                          placeholder={
                            budgetData?.length < 1
                              ? `No budget for ${departmentValue}`
                              : "Choose budget"
                          }
                        />
                      )}
                    />
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Budget Item
                    </h1>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      disabled={!budgetDetails?.result}
                      options={budgetDetails?.result?.map((d, _index) => ({
                        label: `${d?.item} - ${d?.description}`,
                        value: d.id,
                        key: _index,
                        total: d?.total,
                      }))}
                      onChange={(e, newValue) => {
                        // setBudgetValue(newValue?.value || "");
                        setIsId(newValue?.value || "");
                        setTotal(newValue?.total || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Choose budget item"
                        />
                      )}
                    />
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Amount
                    </h1>
                    <TextField
                      value={total?.toLocaleString()}
                      disabled
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
                  <button
                    className=" px-[24px] py-[12px] rounded-[8px] text-baseFont text-customGreen"
                    style={{ border: "1px solid #305f32" }}
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleLinkBudget}
                    disabled={loading}
                    className="bg-[#29382A] text-white px-[24px] py-[12px] rounded-[8px]"
                  >
                    {loading ? "Updating..." : "Update to Budget"}
                  </button>
                </div>
              </div>
            </CustomModal>
          )}
        </>
      </RouteLayout>
    </>
  );
};

export default PaymentDetails;

const PaymentTabLayout = ({ children }) => {
  return (
    <>
      <div className="py-[32px] pl-[24px] pr-[1px] bg-[#F8FBF8]">
        {children}
      </div>
    </>
  );
};
